import { formatCount, severityLabels, trendDays } from './model'

import styles from './ReportedMeetingsPage.module.scss'

import { type ReportOverview, severities } from '@/api/meetingReportsObservability'

const Trend = ({ trend, startAt, endAt }: { trend: ReportOverview['trend']; startAt: string; endAt: string }) => {
  const byDate = new Map(trend.map((point) => [point.date, point.severity]))
  const days = trendDays(startAt, endAt)
  const totals = days.map((day) => {
    const counts = byDate.get(day)
    return counts ? severities.reduce((sum, severity) => sum + counts[severity], 0) : 0
  })
  const max = Math.max(1, ...totals)
  return (
    <figure className={styles.trend}>
      <figcaption>Reports per day by severity</figcaption>
      <div className={styles.trendBars} role="img" aria-label="Daily reports by severity">
        {days.map((day, index) => {
          const counts = byDate.get(day)
          return (
            <div key={day} className={styles.trendBar} title={`${day}: ${formatCount(totals[index])} reports`}>
              {counts &&
                severities.map((severity) =>
                  counts[severity] ? (
                    <span
                      key={severity}
                      className={styles[severity]}
                      style={{ height: `${(counts[severity] / max) * 100}%` }}
                    />
                  ) : null
                )}
            </div>
          )
        })}
      </div>
      <table className={styles.srOnly}>
        <caption>Daily reports by severity</caption>
        <thead>
          <tr>
            <th scope="col">Day</th>
            {severities.map((severity) => (
              <th key={severity} scope="col">
                {severityLabels[severity]}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {days.map((day) => (
            <tr key={day}>
              <th scope="row">{day}</th>
              {severities.map((severity) => (
                <td key={severity}>{byDate.get(day)?.[severity] ?? 0}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </figure>
  )
}

export default Trend
